<div id="commonspinner" *ngIf="showSpinner">
    <mat-progress-spinner style="margin:0 auto;" mode="indeterminate" diameter="50">
    </mat-progress-spinner>
</div>

<div id="loginspinner" *ngIf="showSpin">
    <mat-progress-spinner style="margin:0 auto;" mode="indeterminate" diameter="40">
    </mat-progress-spinner>
</div>